export const saveLocalStorageData = (key: string, data: string): void => {
  try {
    if (typeof window !== 'undefined') {
      localStorage.setItem(key, data);
    }
  } catch (error) {
  }
};

export const getLocalStorageData = (key: string): any => {
  try {
    if (typeof window !== 'undefined') {
      const data = localStorage.getItem(key);
      if (data === null) {
        return null;
      }
      return JSON.parse(data);
    }
    return null;
  } catch (error) {
    return null;
  }
};

export const clearLocalStorageData = (key: string): void => {
  try {
    if (typeof window !== 'undefined' && key) {
      localStorage.removeItem(key);
    }
  } catch (error) {
  }
};

interface UserData {
  email?: string;
  [key: string]: any;
}

/** Cheap, synchronous check: is there a stored user with a non-empty email? */
export const isUserLoggedIn = (userKey: string = 'user', emailKey: string = 'email'): boolean => {
  try {
    if (typeof window === 'undefined') {
      return false;
    }
    
    const userData = getLocalStorageData(userKey);

    if (!userData || typeof userData !== 'object') {
      return false;
    }

    const email = userData[emailKey];
    return Boolean(email && typeof email === 'string' && email.trim().length > 0);
  } catch (error) {
    return false;
  }
};

/** Stored profile id — Academy API uses `uid`, raw login/SSO bodies use `id`/`_id`; accept all three. */
export const getStoredUserId = (user: UserData | null | undefined): string =>
  String(user?.uid ?? user?.id ?? user?._id ?? '');

/** Canonical null-safe reader for the localStorage `user` key. */
export const getUserData = (userKey: string = 'user'): UserData | null => {
  try {
    if (typeof window === 'undefined') {
      return null;
    }
    
    const userData = getLocalStorageData(userKey);
    
    if (!userData || typeof userData !== 'object') {
      return null;
    }
    
    return userData as UserData;
  } catch (error) {
    return null;
  }
};

